'use strict';

/**
 * Shared header for every private-space page.
 *
 *   <PageHeader icon="⭐" title="Mes évaluations" subtitle="…" />
 *
 * Goal is one consistent look across the side-menu app:
 *  - same Georgia serif title at the same size everywhere
 *  - same muted subtitle below
 *  - optional emoji prefix that sits inline with the title
 *
 * The component does NOT render a "back to dashboard" link — that's already
 * always one click away in the left sidebar nav, and adding it per-page was
 * the main source of inconsistency. Per-page contextual back links (e.g. a
 * wizard step returning to its parent list) should stay inside the page body
 * above this header, not inside it.
 */
export default function PageHeader({ icon, title, subtitle, children }) {
  return (
    <header
      style={{
        margin: '0 0 1.5rem',
        paddingBottom: '0.9rem',
        borderBottom: '1px solid rgba(255,255,255,0.07)',
      }}
    >
      <h1
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: '1.6rem',
          color: 'var(--couleur-texte)',
          margin: 0,
          lineHeight: 1.2,
          display: 'flex',
          alignItems: 'center',
          gap: '0.55rem',
        }}
      >
        {icon && (
          <span style={{ fontSize: '1.4rem', lineHeight: 1 }} aria-hidden="true">
            {icon}
          </span>
        )}
        <span>{title}</span>
      </h1>
      {subtitle && (
        <p
          style={{
            color: 'rgba(255,255,255,0.55)',
            fontSize: '0.92rem',
            margin: '0.45rem 0 0',
            lineHeight: 1.45,
          }}
        >
          {subtitle}
        </p>
      )}
      {children}
    </header>
  );
}
